import React from 'react';
import { Box } from '@mui/material';
import { BACKGROUND_GRADIENTS } from '../constants';
import { PropertyTypeNames } from '../../../../system/property-type';
import { Lookup } from 'src/system/lookup';
import { useMetadata } from 'src/contexts/MetadataContext';

interface BackgroundGradientProps {
  propertyType: string;
  navHeight?: number;
}

export const BackgroundGradient: React.FC<BackgroundGradientProps> = ({
  propertyType,
  navHeight = 0,
}) => {
  const { displayValueForListingField } = useMetadata();
  const tenantPropertyType = displayValueForListingField(
    Lookup.PROPERTY_TYPE,
    propertyType,
  );
  const backgroundGradient =
    BACKGROUND_GRADIENTS[tenantPropertyType as PropertyTypeNames] ||
    BACKGROUND_GRADIENTS[PropertyTypeNames.RESIDENTIAL];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: navHeight - 10,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        background: backgroundGradient,
        zIndex: -1,
        pointerEvents: 'none',
      }}
    />
  );
};
